#import "../fragments/broadcast-stub-fragment.graphql"

mutation DuplicateBroadcast($broadcast: EditionDuplicateToBroadcastInput!) {
    editionDuplicateToBroadcast(input: $broadcast) {
        broadcast {
            ...BroadcastStubFragment
        }
    }
}
